<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >盘厂名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate('create')"
                >新增</el-button
              >
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleImport"
                >批量导入项目</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleImportPerformance"
                >导入业绩</el-button
              >
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleImportSupplementary"
                >导入补充企业信息</el-button
              >
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                style="
                  background: #f59a23;
                  color: #ffffff;
                  border-color: #f59a23;
                "
                @click="handleSyncData"
                >同步数据</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="isHome" slot-scope="{ row }">
        <el-switch
          :value="row.isHome"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          v-if="row.image"
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="state" slot-scope="{ row }">
        <el-switch
          :value="row.state"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="address" slot-scope="{ row }">
        <span>{{
          row.authProvince || row.authCity
            ? (row.authProvince || "") + (row.authCity || "")
            : "-"
        }}</span>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleCreate('view', row.id)"
          >详情</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleCreate('update', row.id)"
          >编辑</el-button
        >
        <el-button type="text" size="mini" @click="handlePerformance(row)"
          >业绩维护</el-button
        >
        <el-button type="text" size="mini" @click="jumpProjectInfo(row.id)"
          >项目信息</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          v-if="row.id != 'b8470908e0c341fd2643a017b8d38282'"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <FactoryForm
      ref="formRef"
      @success="handleSearch"
      :classifyList="classifyList"
    />
    <!-- 导入弹窗 -->
    <Import
      v-if="importShow"
      :show="importShow"
      :action="importAction"
      :downloadLink="importDownloadLink"
      :problemLink="importProblem"
      @close="importClose"
    />
    <CompletionRateForm ref="completionRateFormRef" />
  </div>
</template>

<script>
import {
  factoryManageList,
  factoryManageAdd,
  factoryManageUpdate,
  factoryManageDelete,
  factoryManageEquityClassifyList,
  factoryManageDetail,
  factoryManageHomeUpdate,
  factoryManageSyncCreditCode,
} from "@/api/factory/manage";
import { mapGetters } from "vuex";
import { mobilePhoneRule } from "@/utils/formRules";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import FactoryForm from "./FactoryForm.vue";
import Import from "@/components/import";
import CompletionRateForm from "./completionRateForm.vue";
export default {
  name: "index",
  components: {
    FormImgUpload,
    FactoryForm,
    Import,
    CompletionRateForm,
  },
  // computed: {
  // 	...mapGetters(['getButton'])
  // },
  data() {
    return {
      button: {},
      isDetails: false,
      searchData: {
        name: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "盘厂名称",
            prop: "name",
          },
          // {
          //   label: "盘厂简称",
          //   prop: "abbr",
          // },
          {
            label: "盘厂图片",
            prop: "image",
          },
          // {
          //   label: "合作模式",
          //   prop: "cooperate",
          // },
          {
            label: "良信负责人",
            prop: "lxPrincipal",
          },
          {
            label: "良信负责人电话",
            prop: "lxPrincipalPhone",
          },

          {
            label: "所在地",
            prop: "address",
          },
          {
            label: "总授权数",
            prop: "totalAuthNum",
          },
          {
            label: "已用授权数",
            prop: "usedAuthNum",
          },
          {
            label: "首页推荐",
            prop: "isHome",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        image: [],
        equityIds: [],
      },
      dialogPassWordVisible: false,
      dataUrl: "",
      classifyList: [], //分类下拉
      importShow: false, //导入弹窗
      importAction: "/api/web/factory/manage/project/template/import",
      importProblem: "/web/factory/manage/template/error/export",
      importDownloadLink: "/web/factory/manage/project/template/export",
    };
  },
  created() {
    this.getClassifyList();
  },
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      factoryManageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },
    // 添加
    // handleCreate() {
    //   this.form.image = [];
    //   this.isDetails = false;
    //   this.form.id = "";
    //   this.dialogVisible = true;
    // },
    handleCreate(type, id) {
      this.$refs.formRef.open(type, id);
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      // localStorage.removeItem("searchForm");
      this.searchData = {
        title: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    //编辑
    async handleEdit(row) {
      // console.log(row)
      this.isDetails = false;
      factoryManageDetail(row.id).then((res) => {
        this.form = {
          ...res.data,
          image: [res.data.image],
          equityIds: res.data.equityIds ? res.data.equityIds.split(",") : [],
        };
      });
      this.form.id = row.id;
      this.dialogVisible = true;
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        factoryManageDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          // return
          if (form.id) {
            factoryManageUpdate({
              ...form,
              image: form.image[0],
              equityIds: form.equityIds.join(","),
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.showLoadingForm = false;
                  this.onLoad();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            factoryManageAdd({
              ...form,
              image: form.image[0],
              equityIds: form.equityIds.join(","),
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.showLoadingForm = false;
                  this.onLoad();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },

    //权益分类
    getClassifyList() {
      factoryManageEquityClassifyList({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data.map((item, index) => {
            return {
              ...item,
              index,
            };
          });
        }
      });
    },
    //切换是否显示
    handleSwitch(e, id) {
      factoryManageHomeUpdate({
        id: id,
        isHome: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },

    // 批量导入项目
    handleImport() {
      this.importAction = "/api/web/factory/manage/project/template/import";
      this.importProblem = "/web/factory/manage/template/error/export";
      this.importDownloadLink = "/web/factory/manage/project/template/export";
      this.importShow = true;
    },
    // 导入业绩
    handleImportPerformance() {
      this.importAction = "/api/web/factory/manage/performance/template/import";
      this.importProblem =
        "/web/factory/manage/performance/template/error/export";
      this.importDownloadLink =
        "/web/factory/manage/performance/template/export";
      this.importShow = true;
    },
    // 导入补充企业信息
    handleImportSupplementary() {
      this.importAction = "/api/web/factory/manage/info/template/import";
      this.importProblem = "/web/factory/manage/info/template/error/export";
      this.importDownloadLink = "/web/factory/manage/info/template/export";
      this.importShow = true;
    },
    // 导入弹框关闭
    importClose(e) {
      this.importShow = false;
      this.onLoad();
    },
    // 同步数据
    async handleSyncData() {
      try {
        this.$message.info("同步中...");
        const res = await factoryManageSyncCreditCode();
        if (res.code === 200) {
          this.$message.success("同步成功");
          this.onLoad();
        }
      } catch (e) {
        // 异常已由拦截器处理
      }
    },
    // 跳转项目信息
    jumpProjectInfo(id) {
      this.$router.push({
        path: "/factory/project",
        query: { id },
      });
    },
    // 打开业绩维护页面
    handlePerformance(row) {
      this.$router.push({
        path: "/factory/performance",
        query: { id: row.id },
      });
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
img {
  width: 100%;
  height: 100%;
}
</style>
